import { lazy } from "react";
import { Route } from "react-router-dom";

/** Groupe de routes AUTH (3) — SITE_SPEC §3.2. À insérer sous <AppLayout>. */

const Connexion = lazy(() => import("../pages/auth/Connexion"));
const Inscription = lazy(() => import("../pages/auth/Inscription"));
const MotDePasseOublie = lazy(() => import("../pages/auth/MotDePasseOublie"));

export const authRoutes = (
  <>
    <Route path="connexion" element={<Connexion />} />
    <Route path="inscription" element={<Inscription />} />
    <Route path="mot-de-passe-oublie" element={<MotDePasseOublie />} />
  </>
);
